import Vue from 'vue';
export default new Vue();
// Vue全局事件  事件公交车
// eventBus.$emit("name",params);
// eventBus.$on("name",(params)=>{
// })
